import { helper } from '@ember/component/helper';

export function trueStringIfPresent([bool]: [any] /* , hash*/) {
  return bool ? 'true' : false;
}

const trueStringIfPresentHelper = helper(trueStringIfPresent);
export default trueStringIfPresentHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'true-string-if-present': typeof trueStringIfPresentHelper;
  }
}
